export default __webpack_public_path__ + "static/photon_banner-8bb900a29577f85470c9a330c45d9268.png";